import { render, staticRenderFns } from "./BasicNavbar.vue?vue&type=template&id=51b3f88c"
import script from "./BasicNavbar.vue?vue&type=script&lang=js"
export * from "./BasicNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports